import React from 'react'

const PropertyDetail: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Property Details</h1>
      <div className="bg-white rounded-lg shadow p-8 text-center">
        <h2 className="text-2xl font-semibold mb-4">Property Not Found</h2>
        <p className="text-gray-600 mb-4">
          This property doesn't exist or has been removed.
        </p>
        <a href="/" className="text-red-500 hover:text-red-600">
          Return to home page
        </a>
      </div>
    </div>
  )
}

export default PropertyDetail
